import createReactComponent from '../createReactComponent';
export default createReactComponent('armchair', 'IconArmchair', [
  [
    'path',
    {
      d: 'M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5', key: 'svg-1' }],
  ['path', { d: 'M6 19v2', key: 'svg-2' }],
  ['path', { d: 'M18 19v2', key: 'svg-3' }],
]);
